import { getElement, getElements } from '../utils/functional'
import { scrollToY } from '../utils/index'

export default class PageCarousel {
  constructor (el) {
    this.els = {
      el,
      readButtons: getElements('[data-position-read-more]'),
      positionBodies: getElements(['data-position-text']),
      countries: getElements('[data-country]'),
      positions: getElements('[data-position-country]')
    }
    this.rollToggle()
    this.selectCountry()
  }

  rollToggle () {
    this.els.readButtons.forEach(button => {
      button.addEventListener('click', evt => {
        const identifier = button.getAttribute('data-position-read-more')
        getElement(`[data-position-text="${identifier}"]`).classList.toggle(
          'pge-Position_Text-open'
        )
        getElement(
          `[data-position-read-more="${identifier}"]`
        ).classList.toggle('pge-Position_Button-open')
      })
    })
  }

  selectCountry () {
    this.els.countries.forEach(country => {
      country.addEventListener('click', evt => {
        this.els.countries.forEach(country2 => {
          country === country2
            ? country2.classList.add('pge-Location-selected')
            : country2.classList.remove('pge-Location-selected')
        })
        const location = country.getAttribute('data-country')
        const dest = getElement(
          `.pge-Position[data-position-country="${location}"]`
        ).offsetTop

        scrollToY(dest, 100, 'easeInOutSine')
      })
    })
  }
}
